export const enum SettingsPageIds {
  General = 'general',
  FeatureFlags = 'feature_flags',
}

export const enum GeneralSettingsPageTabIds {
  UserAccount = 'user_account',
  UnitSettings = 'unit_settings',
}
